import { useState } from "react"
import Saturation from './Saturation';
import Luminosity from './Luminosity';
import { icons } from "./icons";
import Hue from './Hue'

const MeshFooter = () => {
    const [showAdvanced,setShowAdvanced] = useState(false)

    const advancedControls = showAdvanced ? <>
        <Saturation />
        <Luminosity />
    </> : []

    return <div className='pl-3 h-16 flex-1 flex items-center gap-5'>
        <div onClick={()=>setShowAdvanced(!showAdvanced)} className='cursor-pointer bg-mute-100 dark:bg-slate-800 h-10 w-10 rounded-xl flex items-center justify-center'>{icons.controls}</div>
    {advancedControls}
    <Hue />
    </div>
}

export default MeshFooter;